var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C14.2279 1 16.0324 1.11895 17.4834 1.44141C18.9366 1.76441 20.0478 2.29391 20.877 3.12305C21.7061 3.95216 22.2355 5.0634 22.5586 6.5166C22.881 7.96759 23 9.77209 23 12C23 14.2276 22.8809 16.0315 22.5586 17.4824C22.2355 18.9359 21.7062 20.0477 20.877 20.877C20.1513 21.6026 19.2096 22.0986 18.0117 22.4277L17.4824 22.5586C16.0315 22.8809 14.2276 23 12 23C9.77209 23 7.96759 22.881 6.5166 22.5586C5.0634 22.2355 3.95216 21.7061 3.12305 20.877C2.29391 20.0478 1.76441 18.9366 1.44141 17.4834C1.11895 16.0324 1 14.2279 1 12C1 9.77209 1.11895 7.96758 1.44141 6.5166C1.76441 5.06343 2.29392 3.95217 3.12305 3.12305C3.95217 2.29392 5.06343 1.76441 6.5166 1.44141C7.96758 1.11895 9.77209 1 12 1Z",
    stroke: "#ACACAC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox_unchecked.3dd74fce7f86fd2f5a167e6eadd9aab3.svg";
export { ForwardRef as ReactComponent };